import { useLocation } from 'react-router-dom';

export const useDesignIdQueryParam = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get('design_id');
}